import { mergeStyles } from "@fluentui/react";

export const lightTheme = {
  palette: {
    themePrimary: "#2f80ed",
    themeLighterAlt: "#020509",
    themeLighter: "#081526",
    themeLight: "#0e2747",
    themeTertiary: "#1c4e8e",
    themeSecondary: "#2a72d1",
    themeDarkAlt: "#438def",
    themeDark: "#5f9ef1",
    themeDarker: "#87b7f5",
    neutralLighterAlt: "#f8f8f8",
    neutralLighter: "#f4f4f4",
    neutralLight: "#eaeaea",
    neutralQuaternaryAlt: "#dadada",
    neutralQuaternary: "#d0d0d0",
    neutralTertiaryAlt: "#c8c8c8",
    neutralTertiary: "#0f0f0f",
    neutralSecondary: "#1f1f1f",
    neutralPrimaryAlt: "#2d2d2d",
    neutralPrimary: "#000000",
    neutralDark: "#646464",
    black: "#8d8d8d",
    white: "#ffffff",
    textfield: "#FAF9F8",
    viewerPathologyBackground: "#CBC9C6",
    activeTool: "#0085FF",
    inactiveTool: "#424242",
    clinicalTools:"#FFFFFF",
    border: "#878787",
    viewerButtonColor: "rgb(0, 120, 212, 0.9)",
    actionDetailsHover: "rgba(134, 167, 255, 0.3)"
  },
  components: {
    TextField: {
      styles: {
        root:{
          borderRadius: "7px",
          colorScheme:"none",
        },
        fieldGroup: [
          {
            background: "transparent",
            border: "1px solid #767676",
            borderColor:'#767676',
            borderRadius: "7px",
            selectors: {
              ":hover": {
                border: "1px solid #000",
              },
              "::after": {
                border: "0px solid #000 !important"
              }
            },
          },
        ],
        field: {
          // border: "none"
          //  border: "1px solid #bfbfbf",
          borderRadius: "7px",
          color: "#000000 !important"
        },
        errorMessage : {
          color: "red",
          fontWeight: "700"
        },
        autofill: mergeStyles({
          'input:-webkit-autofill': {
            backgroundColor: 'yellow', // Example style for autofilled fields
          },
        }),
      },
    },
    ComboBox : {
      styles: {
        root: {
          width: "100%",
          borderRadius: "5px !important",
          backgroundColor: "transparent",
          selectors: {
            ":hover": {
              border: "1px solid #000",
            },
            "::after": {
              borderRadius: "5px !important",
              border: "1px solid #000",
            },
          },
        },
        input: {
          color: "black",
          backgroundColor: "transparent",
        },
        label :{
          color: "black"
        },
        optionsContainer: {
          color: "black"
        },
        optionsContainerWrapper: {
          maxHeight: "300px",
          width: "100% !important",
        },
        rootError: {
          border: "1px solid rgb(164, 38, 44)",
        },
        callout :{
          width: "100%",
          right: "0px",
          backgroundColor: "#262525 !important",
        },
        errorMessage :{
          color: "red",
          fontWeight: "700"
        },
        calloutMain: {
          backgroundColor: "#262525",
        }
      }
    },
    Checkbox: {
      styles: {
        root: {
          margin: "10px 0",
          colorScheme:"none",
        },
        text: {
          color: "#000",
        },
        checkbox: {
          borderColor: "#000",
          colorScheme:"none",
        },
      },
    },
    SearchBox: {
      styles: {
        root: {
          border: "1px solid #767676",
          backgroundColor: "transparent",
          borderRadius: "7px"
        },
      },
    },
    Layer: {
      styles: {
        content: {
          background: "#000000",
        },
      },
    },
    PrimaryButton: {
      styles: {
        root: {
          
          color: "#FAFAFA",
          backgroundColor: "rgb(0, 120, 212)",
          borderRadius: "7px",
          padding:'0px 5px',
          height:'30px',
          selectors: {
            ":hover": {
              // backgroundColor: 'green'
            },
          },
          
        },
        label:{
          fontSize: '14px',
          fontWeight:'600',
          fontFamily:'Open Sans',
        },
        textContainer:{
          display:'flex',
          justifyContent:'center'
        },
        icon:{
          fontSize: "14px"
        }
      },
    },
    DefaultButton: {
      styles: {
        root: {
          color: "#000",
          backgroundColor: "transparent",
          borderRadius: "7px",
          whiteSpace: "nowrap",
          height:'30px',
          selectors: {
            ":hover": {
              color: "#000",
            },
          },
        },
        label:{
          fontSize: '14px',
          fontWeight:'600',
          fontFamily:'Open Sans',
        },
        textContainer:{
          display:'flex',
          justifyContent:'center'
        },
        icon:{
          fontSize: "14px"
        }
      },
    },
    Separator: {
      styles: {
        root: [
          {
            height: "1px",
            selectors: {
              // add selectors here
              "::before": {
                background: "#201F1E",
              },
            },
          },
        ],
      },
    },
    Pivot: {
      styles: {
        root: [
          {
            linkIsSelected: {
              "::before": {
                background: "#C6E5F6",
              },
            },
          },
        ],
      },
    },
    Dropdown: {
      styles: {
        title: {
          background: "transparent",
          border: "1px solid #767676",
          borderRadius: "7px"
        },
        dropdownOptionText:{
          color: "#000"
        },
        dropdownItem: 
        {
          selectors: {
            ":hover": {
              backgroundColor: "#e4e0e0",
            },
          },
        },
        dropdownItemSelected: {
          background: "e4e0e0",
          selectors: {
            ":hover": {
              backgroundColor: "#e4e0e0",
            },
          },
        },
        errorMessage :{
          color: "red",
          fontWeight: "700"
        }
      },
    },
    Dialog: {
      styles: {
        main: [
          {
            backgroundColor: "#EDEBE9",
          },
        ],
      },
    },
    Modal: {
      styles: {
        main: [
          {
            backgroundColor: "#EDEBE9",
          },
        ],
      },
    }
  },
};

export const darkTheme = {
  palette: {
    themePrimary: "#0078d4",
    themeLighterAlt: "#eff6fc",
    themeLighter: "#deecf9",
    themeLight: "#c7e0f4",
    themeTertiary: "#71afe5",
    themeSecondary: "#2b88d8",
    themeDarkAlt: "#106ebe",
    themeDark: "#005a9e",
    themeDarker: "#004578",
    neutralLighterAlt: "#0b0600",
    neutralLighter: "#150b02",
    neutralLight: "#251505",
    neutralQuaternaryAlt: "#2f1c09",
    neutralQuaternary: "#37210c",
    neutralTertiaryAlt: "#593c1f",
    neutralTertiary: "#c8c8c8",
    neutralSecondary: "#d0d0d0",
    neutralPrimaryAlt: "#dadada",
    neutralPrimary: "#ffffff",
    neutralDark: "#f4f4f4",
    black: "#f8f8f8",
    white: "#000000",
    textfield: "#201F1E",
    viewerPathologyBackground: "#201F1E",
    activeTool: "#0085FF",
    inactiveTool: "#C1C1C1",
    clinicalTools:"#424242",
    border: "#3B3A39",
    viewerButtonColor: "rgb(0, 120, 212)",
    actionDetailsHover: "#61759047"
  },
  components: {
    TextField: {
      styles: {
        root:{
          borderRadius: "7px"
        },
        fieldGroup: [
          {
            background: "transparent",
            border: "1px solid #585858",
            borderRadius: "7px",
            selectors: {
              ":hover": {
                border: "1px solid #bfbfbf",
              },
              "::after": {
                border: "0px solid #bfbfbf !important"
              }
            },
          },
        ],
        field: {
          // border: "none"
          //  border: "1px solid #bfbfbf",
          borderRadius: "7px",
        },
        errorMessage : {
          color: "red",
          fontWeight: "700"
        }
      },
    },
    ComboBox : {
      styles: {
        root: {
          width: "100%",
          borderRadius: "7px !important",
          backgroundColor: "transparent",
          selectors: {
            ":hover": {
              border: "1px solid #bfbfbf",
            },
            "::after": {
              borderRadius: "7px !important",
              border: "1px solid #585858",
            },
          },
        },
        input: {
          color: "white",
          backgroundColor: "transparent",
        },
        optionsContainer: {
          backgroundColor: '#101e30'
        },
        optionsContainerWrapper: {
          maxHeight: "300px",
          width: "100% !important",
        },
        rootError: {
          border: "1px solid #585858",
        },
        callout :{
          calloutMain: {
            backgroundColor: "red",
          },
          width: "100%",
          right: "0px",
          backgroundColor: "red !important",
        },
        errorMessage :{
          color: "red",
          fontWeight: "700"
        },
        
      }
    },
    Checkbox: {
      styles: {
        root: {
          margin: "10px 0",
        },
        text: {
          color: "#A19F9D",
        },
        checkbox: {
          borderColor: "#A19F9D",
        },
      },
    },
    SearchBox: {
      styles: {
        root: {
          border: "1px solid #585858",
          backgroundColor: "transparent",
          borderRadius: "7px"
        },
      },
    },
    Layer: {
      styles: {
        content: {
          background: "#000000",
        },
      },
    },
    PrimaryButton: {
      styles: {
        root: {
          
          color: "#FAFAFA",
          backgroundColor: "rgb(0, 120, 212)",
          borderRadius: "7px",
          padding:'0px 5px',
          height:'30px',
          selectors: {
            ":hover": {
              // backgroundColor: 'green'
            },
          },
          
        },
        label:{
          fontSize: '14px',
          fontWeight:'600',
          fontFamily:'Open Sans',
        },
        textContainer:{
          display:'flex',
          justifyContent:'center'
        },
        icon:{
          fontSize: "14px"
        }
      },
    },
    DefaultButton: {
      styles: {
        root: {
          color: "#FAFAFA",
          backgroundColor: "transparent",
          borderRadius: "7px",
          height:'30px',
          whiteSpace: "nowrap",
          selectors: {
            ":hover": {
              color: "#FAFAFA",
            },
          },
        },
        label:{
          fontSize: '14px',
          fontWeight:'600',
          fontFamily:'Open Sans',
        },
        textContainer:{
          display:'flex',
          justifyContent:'center'
        },
        icon:{
          fontSize: "14px"
        }
      },
    },
    Separator: {
      styles: {
        root: [
          {
            height: "1px",
            selectors: {
              // add selectors here
              "::before": {
                background: "#201F1E",
              },
            },
          },
        ],
      },
    },
    PivotItem: {
      styles: {
        root: [
          {
            linkIsSelected: {
              "::before": {
                background: "#C6E5F6",
              },
            },
          },
        ],
      },
    },
    ToolTipHost: {
      root:{
        background: "green"
      },
        calloutProps: {
          styles: {
            beak: { background: "#252525;" },
            beakCurtain: { background: "#252525;" },
            calloutMain: { background: "#252525;" },
            borderRadius: "20%",
          },
        },
    },
    Calendar: {
      styles: {
        root: {
          backgroundColor: "#101e30",
          color: 'white',
        }
      },
    },
    Dropdown: {
      styles: {
        title: {
          background: "transparent",
          border: "1px solid #585858",
          borderRadius: "7px"
        },
        dropdownItemsWrapper :{
            background: "#101e30",
        },
        dropdownItem: {
          background: "#101e30",
          selectors: {
            ":hover": {
              backgroundColor: "#61759047",
            },
          },
        },
        dropdownItemSelected: {
          background: "#141414",
          selectors: {
            ":hover": {
              backgroundColor: "#141414",
            },
          },
        },
        errorMessage :{
          color: "red",
          fontWeight: "700"
        }
      },
    },
    Dialog: {
      styles: {
        main: [
          {
            backgroundColor: "#161514",
            minWidth: 800,
          },
        ],
      },
    },
    Modal: {
      styles: {
        main: [
          {
            backgroundColor: "#161514",
          },
        ],
      },
    },
  },
};

export const royalBlueTheme = {
  palette: {
    themePrimary: "#0078d4",
    themeLighterAlt: "#eff6fc",
    themeLighter: "#deecf9",
    themeLight: "#c7e0f4",
    themeTertiary: "#71afe5",
    themeSecondary: "#2b88d8",
    themeDarkAlt: "#106ebe",
    themeDark: "#005a9e",
    themeDarker: "#004578",
    neutralLighterAlt: "#0b0600",
    neutralLighter: "#150b02",
    neutralLight: "#251505",
    neutralQuaternaryAlt: "#2f1c09",
    neutralQuaternary: "#37210c",
    neutralTertiaryAlt: "#593c1f",
    neutralTertiary: "#c8c8c8",
    neutralSecondary: "#d0d0d0",
    neutralPrimaryAlt: "#dadada",
    neutralPrimary: "#ffffff",
    neutralDark: "#f4f4f4",
    black: "#f8f8f8",
    white: "#000000",
    textfield: "#201F1E",
    viewerPathologyBackground: "#201F1E",
    activeTool: "#0085FF",
    inactiveTool: "#C1C1C1",
    clinicalTools:"#424242",
    border: "#3B3A39",
    viewerButtonColor: "rgb(0, 120, 212)",
    actionDetailsHover: "#314083"
  },
  components: {
    TextField: {
      styles: {
        root:{
          borderRadius: "7px"
        },
        fieldGroup: [
          {
            background: "transparent",
            border: "1px solid #585858",
            borderRadius: "7px",
            selectors: {
              ":hover": {
                border: "1px solid #bfbfbf",
              },
              "::after": {
                border: "0px solid #bfbfbf !important"
              }
            },
          },
        ],
        field: {
          // border: "none"
          //  border: "1px solid #bfbfbf",
          borderRadius: "7px",
        },
        errorMessage : {
          color: "red",
          fontWeight: "700"
        }
      },
    },
    ComboBox : {
      styles: {
        root: {
          width: "100%",
          borderRadius: "7px !important",
          backgroundColor: "transparent",
          selectors: {
            ":hover": {
              border: "1px solid #bfbfbf",
            },
            "::after": {
              borderRadius: "7px !important",
              border: "1px solid #585858",
            },
          },
        },
        input: {
          color: "white",
          backgroundColor: "transparent",
        },
        optionsContainer: {
          backgroundColor: '#1D2858'
        },
        optionsContainerWrapper: {
          maxHeight: "300px",
          width: "100% !important",
        },
        rootError: {
          border: "1px solid #585858",
        },
        callout :{
          width: "100%",
          right: "0px",
          backgroundColor: "red !important",
        },
        errorMessage :{
          color: "red",
          fontWeight: "700"
        },
        calloutMain: {
          backgroundColor: "#262525",
        }
      }
    },
    Checkbox: {
      styles: {
        root: {
          margin: "10px 0",
        },
        text: {
          color: "#A19F9D",
        },
        checkbox: {
          borderColor: "#A19F9D",
        },
      },
    },
    SearchBox: {
      styles: {
        root: {
          border: "1px solid #585858",
          backgroundColor: "transparent",
          borderRadius: "7px"
        },
      },
    },
    Layer: {
      styles: {
        content: {
          background: "#000000",
        },
      },
    },
    PrimaryButton: {
      styles: {
        root: {
          
          color: "#FAFAFA",
          backgroundColor: "rgb(0, 120, 212)",
          borderRadius: "7px",
          padding:'0px 5px',
          height:'30px',
          selectors: {
            ":hover": {
              // backgroundColor: 'green'
            },
          },
          
        },
        label:{
          fontSize: '14px',
          fontWeight:'600',
          fontFamily:'Open Sans',
        },
        textContainer:{
          display:'flex',
          justifyContent:'center'
        },
        icon:{
          fontSize: "14px"
        }
      },
    },
    DefaultButton: {
      styles: {
        root: {
          color: "#FAFAFA",
          backgroundColor: "transparent",
          borderRadius: "7px",
          height:'30px',
          whiteSpace: "nowrap",
          selectors: {
            ":hover": {
              color: "#FAFAFA",
            },
          },
        },
        label:{
          fontSize: '14px',
          fontWeight:'600',
          fontFamily:'Open Sans',
        },
        textContainer:{
          display:'flex',
          justifyContent:'center'
        },
        icon:{
          fontSize: "14px"
        }
      },
    },
    Separator: {
      styles: {
        root: [
          {
            height: "1px",
            selectors: {
              // add selectors here
              "::before": {
                background: "#201F1E",
              },
            },
          },
        ],
      },
    },
    PivotItem: {
      styles: {
        root: [
          {
            linkIsSelected: {
              "::before": {
                background: "#C6E5F6",
              },
            },
          },
        ],
      },
    },
    ToolTipHost: {
      root:{
        background: "green"
      },
        calloutProps: {
          styles: {
            beak: { background: "#252525;" },
            beakCurtain: { background: "#252525;" },
            calloutMain: { background: "#252525;" },
            borderRadius: "20%",
          },
        },
    },
    Calendar: {
      styles: {
        root: {
          backgroundColor: "#1D2858",
          color: 'white',
        }
      },
    },
    Dropdown: {
      styles: {
        title: {
          background: "transparent",
          border: "1px solid #585858",
          borderRadius: "7px"
        },
        dropdownItemsWrapper :{
          background: "#1D2858",
      },
        dropdownItem: {
          background: "#1D2858",
          selectors: {
            ":hover": {
              backgroundColor: "#61759047",
            },
          },
        },
        dropdownItemSelected: {
          background: "#263345",
          selectors: {
            ":hover": {
              backgroundColor: "#263345",
            },
          },
        },
      },
    },
    Dialog: {
      styles: {
        main: [
          {
            backgroundColor: "#161514",
            minWidth: 800,
          },
        ],
      },
    },
    Modal: {
      styles: {
        main: [
          {
            backgroundColor: "#161514",
          },
        ],
      },
    },
  },
};

export const duskTheme = {
  palette: {
    themePrimary: "#0078d4",
    themeLighterAlt: "#eff6fc",
    themeLighter: "#deecf9",
    themeLight: "#c7e0f4",
    themeTertiary: "#71afe5",
    themeSecondary: "#2b88d8",
    themeDarkAlt: "#106ebe",
    themeDark: "#005a9e",
    themeDarker: "#004578",
    neutralLighterAlt: "#0b0600",
    neutralLighter: "#150b02",
    neutralLight: "#251505",
    neutralQuaternaryAlt: "#2f1c09",
    neutralQuaternary: "#37210c",
    neutralTertiaryAlt: "#593c1f",
    neutralTertiary: "#c8c8c8",
    neutralSecondary: "#d0d0d0",
    neutralPrimaryAlt: "#dadada",
    neutralPrimary: "#ffffff",
    neutralDark: "#f4f4f4",
    black: "#f8f8f8",
    white: "#000000",
    textfield: "#201F1E",
    viewerPathologyBackground: "#201F1E",
    activeTool: "#0085FF",
    inactiveTool: "#C1C1C1",
    clinicalTools:"#424242",
    border: "#3B3A39",
    viewerButtonColor: "rgb(0, 120, 212, 0.9)",
    actionDetailsHover: "#333334"
  },
  components: {
    TextField: {
      styles: {
        root:{
          borderRadius: "7px"
        },
        fieldGroup: [
          {
            background: "transparent",
            border: "1px solid #585858",
            borderRadius: "7px",
            selectors: {
              ":hover": {
                border: "1px solid #bfbfbf",
              },
              "::after": {
                border: "0px solid #bfbfbf !important"
              }
            },
          },
        ],
        field: {
          // border: "none"
          //  border: "1px solid #bfbfbf",
          borderRadius: "7px",
        },
        errorMessage : {
          color: "red",
          fontWeight: "700"
        }
      },
    },
    ComboBox : {
      styles: {
        root: {
          width: "100%",
          borderRadius: "7px !important",
          backgroundColor: "transparent",
          selectors: {
            ":hover": {
              border: "1px solid #bfbfbf",
            },
            "::after": {
              borderRadius: "7px !important",
              border: "1px solid #585858",
            },
          },
        },
        input: {
          color: "white",
          backgroundColor: "transparent",
        },
        optionsContainer: {
          backgroundColor: '#3e3f43'
        },
        optionsContainerWrapper: {
          maxHeight: "300px",
          width: "100% !important",
        },
        rootError: {
          border: "1px solid #585858",
        },
        callout :{
          width: "100%",
          right: "0px",
          backgroundColor: "#262525 !important",
        },
        errorMessage :{
          color: "red",
          fontWeight: "700"
        },
        calloutMain: {
          backgroundColor: "#262525",
        }
      }
    },
    Checkbox: {
      styles: {
        root: {
          margin: "10px 0",
        },
        text: {
          color: "#A19F9D",
        },
        checkbox: {
          borderColor: "#A19F9D",
        },
      },
    },
    SearchBox: {
      styles: {
        root: {
          border: "1px solid #585858",
          backgroundColor: "transparent",
          borderRadius: "7px"
        },
      },
    },
    Layer: {
      styles: {
        content: {
          background: "#000000",
        },
      },
    },
    PrimaryButton: {
      styles: {
        root: {
          
          color: "#FAFAFA",
          backgroundColor: "rgb(0, 120, 212)",
          borderRadius: "7px",
          padding:'0px 5px',
          height:'30px',
          selectors: {
            ":hover": {
              // backgroundColor: 'green'
            },
          },
          
        },
        label:{
          fontSize: '14px',
          fontWeight:'600',
          fontFamily:'Open Sans',
        },
        textContainer:{
          display:'flex',
          justifyContent:'center'
        },
        icon:{
          fontSize: "14px"
        }
      },
    },
    DefaultButton: {
      styles: {
        root: {
          color: "#FAFAFA",
          backgroundColor: "transparent",
          borderRadius: "7px",
          height:'30px',
          whiteSpace: "nowrap",
          selectors: {
            ":hover": {
              color: "#FAFAFA",
            },
          },
        },
        label:{
          fontSize: '14px',
          fontWeight:'600',
          fontFamily:'Open Sans',
        },
        textContainer:{
          display:'flex',
          justifyContent:'center'
        },
        icon:{
          fontSize: "14px"
        }
      },
    },
    Separator: {
      styles: {
        root: [
          {
            height: "1px",
            selectors: {
              // add selectors here
              "::before": {
                background: "#201F1E",
              },
            },
          },
        ],
      },
    },
    PivotItem: {
      styles: {
        root: [
          {
            linkIsSelected: {
              "::before": {
                background: "#C6E5F6",
              },
            },
          },
        ],
      },
    },
    ToolTipHost: {
      root:{
        background: "green"
      },
        calloutProps: {
          styles: {
            beak: { background: "#252525;" },
            beakCurtain: { background: "#252525;" },
            calloutMain: { background: "#252525;" },
            borderRadius: "20%",
          },
        },
    },
    Calendar: {
      styles: {
        root: {
          backgroundColor: "#3e3f43",
          color: 'white',
        }
      },
    },
    Dropdown: {
      styles: {
        title: {
          background: "transparent",
          border: "1px solid #585858",
          borderRadius: "7px"
        },
        dropdownItemsWrapper :{
          background: "#3e3f43",
        },
        dropdownItem: {
          background: "#3e3f43",
          selectors: {
            ":hover": {
              backgroundColor: "#4b4b4b",
            },
          },
        },
        dropdownItemSelected: {
          background: "#141414",
          selectors: {
            ":hover": {
              backgroundColor: "#141414",
            },
          },
        },
      },
    },
    Dialog: {
      styles: {
        main: [
          {
            backgroundColor: "#161514",
            minWidth: 800,
          },
        ],
      },
    },
    Modal: {
      styles: {
        main: [
          {
            backgroundColor: "#161514",
          },
        ],
      },
    },
  },
};
